import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { message, Modal as AntdModal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import apiClient from 'utils/apiClient';
import useHandleError from 'utils/useHandleError';
import generalHelpers from 'utils/generalHelpers';

const mapStateToProps = (state: any) => ({
    session: state.session,
});

interface DeleteTaskMenuItemInterface {
    attemptId: number;
    onDone: Function;
    session?: any;
}

/**
 * 24.3.7 - PowerAdmin deletes a grading task. One shared row-action menu item
 * for both grading tabs (the app-wide Popover "popover-item" pattern) with the
 * standard destructive confirm (warning icon + red "Delete").
 * Renders nothing for users without the delete_grading_tasks special right.
 */
const DeleteTaskMenuItem: React.FC<DeleteTaskMenuItemInterface> = ({ attemptId, onDone, session }) => {
    const intl = useIntl();
    const [handleError] = useHandleError();

    if (!generalHelpers.hasSpecialPermissions(session, 'delete_grading_tasks')) {
        return null;
    }

    const confirmDelete = () => {
        AntdModal.confirm({
            title: intl.formatMessage({ id: 'grading.delete_task' }),
            icon: <ExclamationCircleOutlined />,
            content: intl.formatMessage({ id: 'grading.delete_task_confirm' }),
            okText: intl.formatMessage({ id: 'general.yes' }),
            okType: 'primary',
            cancelText: intl.formatMessage({ id: 'general.no' }),
            onOk: async () => {
                try {
                    await apiClient.request(`/api/v1/courses/grading/delete-task/${attemptId}`, {}, 'POST');
                    message.success(intl.formatMessage({ id: 'grading.task_deleted_success' }));
                    onDone();
                } catch (error) {
                    handleError(error);
                }
            },
        });
    };

    return (
        <div className="popover-item" onClick={confirmDelete}>
            <FormattedMessage id="general.delete" />
        </div>
    );
};

export default connect(mapStateToProps)(DeleteTaskMenuItem);
